import styled from 'styled-components';

export const StyledFooterContainer = styled.div`
	// background: black;
	// padding: 5% 5% 2%;
`;
export const StyledBootmFooterContainer = styled.div`
	background: #0a0a0a;
	padding-top: 9px;
	padding-bottom: 9px;
`;

export const StyledFooterList = styled.ul`
	list-style: none;
	margin-left: 3rem;
	padding-left: 1rem;
	font-family: Poppins, sans-serif;

	@media screen and (max-width: 768px) {
		margin-left: 0;
		padding-left: 0;
		border-left: none;
		max-width: 350px;
		overflow: hidden;
	}
`;
export const Styledwhite = styled.div`
	color: white;
	font-weight: 100;
	padding-right: 5px;
`;

export const StyledMegaFootertwo = styled.div`
	color: gray;
	font-family: Poppins, sans-serif;
	display: flex;
	justify-content: right;
	font-size: 12px;

	@media screen and (max-width: 768px) {
		margin-left: 0;
		padding-left: 0;
		border-left: none;
		text-align: center;
		justify-content: center;
	}
`;
export const StyledMegaFooter = styled.div`
	color: gray;
	font-family: Poppins, sans-serif;
	font-size: 12px;
	@media screen and (max-width: 768px) {
		margin-left: 0;
		padding-left: 0;
		border-left: none;
		text-align: center;
	}
`;

export const StyledFooterHeadingItem = styled.div`
	color: white;
	font-weight: 900;
	font-size: 110%;
	font-family: 'Poppins', sans-serif;
	margin-bottom: 20px;
`;

export const StyledFooterListItem = styled.li`
	// font-size: 13px;
	// font-weight: 300;
	// line-height: 24px;
	// font-family: Poppins, sans-serif;
	// padding-top: 2px;
	// padding-bottom: 2px;
`;

export const StyledFooterListAnchor = styled.a`
	text-decoration: none;
	color: white;
	cursor: pointer;

	&:hover {
		text-decoration: none;
		color: #ed3237;
	}
`;

export const StyledFooterIconImage = styled.img`
	margin-top: 25%;

	@media screen and (max-width: 768px) {
		margin-top: 0;
	}
`;
export const Styledborder = styled.img`
	width: 35px;
	border-top: solid 3px;
	border-color: red;
	height: 3px;
	margin-top: 5px;
`;

export const StyledFooterImage = styled.div`
	margin-bottom: 10px;
	margin-left: 5px;
	display: flex;
	max-width: 200px;
	@media screen and (max-width: 768px) {
		display: block;
	}
`;
export const StyledFooterImage1 = styled.div`
	margin: 5px;
	display: flex;
	max-width: 250px;
	cursor: pointer;
	@media screen and (max-width: 768px) {
		display: flex;
	}
`;
export const StyledFooter1Image = styled.div`
	margin-top: 10px;
	display: flex;
	over-flow: hidden;
	cursor: pointer;
	margin-right: 5px;
`;
